import { toBigNumber } from '@injectivelabs/utils/big-number'
import type { IntervalOption } from '@/types'

export * from './setup'

// export * from './campaign'
// export * from './mega-vault'

export const TRUE_CURRENT_CID_PREFIX = 'tc-web'

export const UI_DEFAULT_MIN_DISPLAY_DECIMALS = 2
export const UI_DEFAULT_PRICE_DISPLAY_DECIMALS = 4
export const UI_DEFAULT_AMOUNT_DISPLAY_DECIMALS = 4
export const UI_DEFAULT_FUNDING_RATE_DECIMALS = 5

export const UI_DEFAULT_LEVERAGE = '1'

export const UI_MAX_PAGINATION_LIMIT_COUNT = 50

export const MAX_SLIPPAGE = toBigNumber(10) // +10% slippage
export const MIN_SLIPPAGE = toBigNumber(0.01) // +0.01% slippage
export const DEFAULT_SLIPPAGE = toBigNumber(0.5) // +0.5% slippage
export const HIGH_SLIPPAGE_THRESHOLD = toBigNumber(5) // +5% slippage
export const DEFAULT_MIN_PRICE_BAND_DIFFERENCE = toBigNumber(80) // -80%
export const DEFAULT_MAX_PRICE_BAND_DIFFERENCE = toBigNumber(400) // +400%
export const DEFAULT_TP_SL_PERCENTAGE = 0.1
export const DEFAULT_SL_LIQUIDATION_BUFFER_PERCENTAGE = 0.005 // 0.5%
export const AGGRESSIVE_LIMIT_PRICE_GUARD_PERCENTAGE = 0.025 // 2.5%

export const DATE_TIME_DISPLAY = 'dd MMM HH:mm:ss'

export const UI_DEFAULT_PAGINATION_LIMIT_COUNT = 10

export const TC_AVAILABLE_MARKETS = 200
export const TC_DEFAULT_VISIBLE_MARKETS = 30

export const DEFAULT_TABLE_ITEMS_AMOUNT = 100

export const DEFAULT_TRUNCATE_LENGTH = 4

export const ORDERBOOK_ROW_HEIGHT = 26
export const ORDERBOOK_ROWS = 9
export const DEFAULT_MIN_GAS = 1_000_000_000_000_000 // 0.001 INJ
export const MIN_QUOTE_ORDER_AMOUNT = 10 // 10 USDT
export const MARK_STRESS_TOLERANCE = 0.002 // 0.2% headroom against mark drift
export const LEVERAGE_STEPS = [
  1, 2, 3, 5, 10, 20, 25, 50, 100, 150, 200
] as const

export const intervalOptions: IntervalOption[] = [
  { label: '1m', value: { resolution: 1, countback: 30 * 32 } },
  { label: '5m', value: { resolution: 5, countback: 30 * 32 } },
  { label: '15m', value: { resolution: 15, countback: 30 * 32 } },
  { label: '30m', value: { resolution: 30, countback: 30 * 32 } },
  { label: '1h', value: { resolution: 60, countback: 30 * 32 } },
  { label: '2h', value: { resolution: 120, countback: 30 * 16 } },
  { label: '4h', value: { resolution: 240, countback: 30 * 10 } },
  { label: '12h', value: { resolution: 720, countback: 30 * 10 } },
  { label: '1D', value: { resolution: 1440, countback: 30 * 10 } }
]

export const LIGHT_CHART_MARKET_IDS = [
  '0xe5bfc48fc29146d756c9dac69f096d56cc4fc5ae75c98c1ad045c3356d14eb82' // AIX/USDT PERP
]

export const DEFAULT_100_CHART_CANDLE_BAR_SPACING = 9.2
export const CHART_ZOOM_FALLBACK_NUMBER = 0.5

export const MAX_LIMIT_ORDER_LINES = 3

export const CHART_DEBOUNCE_DEFAULT_PERIOD = 200 // 200ms
export const CID_SUFFIX_MAX_LENGTH = 20

export const IS_ORDERBOOK_ENABLED = true

export const TC_MEMO = { appId: 'tc-web' }

export const SHARING_CARDS_DIMENSIONS = {
  width: 1520,
  height: 1080
}

export const MIXPANEL_UTM_STORAGE_KEY = 'mixpanel_utm'
export const MIXPANEL_DEVICE_TYPE = 'desktop' as const
export const MIXPANEL_BRIDGE_METHOD = 'manual' as const

export const RFQ_TOAST_KEY = 'rfq-toast'
